import React from 'react';
import styled from 'styled-components';

import IndexVars from '../../../../shared-components/variables/VariableIndex';
import VariableFeatures from '../../../../shared-components/variables/VariableFeatures';
import VariableTextSize from '../../../../shared-components/variables/VariableTextSize.js';
import SizeVars from '../../../../shared-components/variables/VariableSize';
import PositionVars from '../../../../shared-components/variables/VariablePositions';
import {ColorTheme} from '../../../../shared-components/variables/feature-colors/ColorTheme';
import {toolTipBtnSetup} from './ConfirmButtonSetup';

const ToolTipContainer = styled.div`
    ${IndexVars}
    ${SizeVars}
    ${PositionVars}
    ${VariableFeatures}
    ${VariableTextSize}
    --arrow-height: 8px;
    padding: var(--space);
    border-radius: 4px;
    margin-top: var(--arrow-height);
    margin: 0px;
    z-index: 9000;
    position: absolute;
    box-shadow: var(--shadow-dark-09) !important;
    background: var(--default-tooltip-background-color);

    h3 {
        color: var(--white-00);
        margin-bottom: var(--space-sm);
    }
    ${({color}) => toolTipBtnSetup(color)};
`;
const ConfirmButtonTooltip = React.forwardRef(({children, title, color, ...rest}, ref) => (
    <ColorTheme>
        <ToolTipContainer color={color} ref={ref} {...rest}>
            <h3>{title}</h3>
            {children}
        </ToolTipContainer>
    </ColorTheme>
));

ConfirmButtonTooltip.displayName = 'Tooltip';

export {ConfirmButtonTooltip, ToolTipContainer};
